export const API_URL = 'https://admin.qubic.market/market';
export const AUTH_REDIRECT_URL = 'https://auth.qubic.app/login';
export const MARKET_API_URL = 'https://creator.qubic.app/market/graphql';
